<template>
    <div>
        <el-form :inline="true" @submit.native.prevent="reload">
            <el-form-item v-if="$root.couldExport">
                <el-button @click="form.tools[0].click">{{form.tools[0].label}}</el-button>
            </el-form-item>
            <form-item :config="form.configs[0]"></form-item>
            <form-item :config="form.configs[1]"></form-item>
            <form-item :config="form.configs[2]"></form-item>
<!--            <form-item :config="form.configs[3]"></form-item>-->
            <el-form-item label="时间">
                <el-date-picker v-model="form.configs[3].value"
                                type="datetimerange" range-separator="~"
                                :default-time="['00:00:00', '23:59:59']"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickOptions"></el-date-picker>
            </el-form-item>
            <form-item :config="form.configs[4]"></form-item>
            <el-button type="primary" native-type="submit">查询</el-button>
            <el-button @click="clear">重置</el-button>
        </el-form>
        <el-table :data="data">
            <el-table-column type="expand">
                <template #default="{row}">
                    <el-form label-position="left" class="table-expand">
                        <el-form-item label="部门名称">{{$root.getCustomerName(row.code)}}</el-form-item>
<!--                        <el-form-item label="短信通道">{{getChannelName(row.channel)}}</el-form-item>-->
                        <el-form-item label="短信内容">{{row.content}}</el-form-item>
                        <el-form-item label="成功条数">{{row.successCount}}</el-form-item>
                        <el-form-item label="失败条数">{{row.failCount}}</el-form-item>
                        <el-form-item label="状态描述">{{row.errMsg}}</el-form-item>
                        <el-form-item label="推送时间">{{row.pushTime}}</el-form-item>
                        <el-form-item label="备注">{{row.remark}}</el-form-item>
                    </el-form>
                </template>
            </el-table-column>
            <el-table-column prop="code" label="业务名称">
                <template #default="{row}">
                    {{$root.getBusinessName(row.code)}}
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号" width="110"></el-table-column>
            <el-table-column prop="totalCount" label="计费条数" width="80"></el-table-column>
            <el-table-column prop="submitTime" label="提交时间" width="150"></el-table-column>
            <el-table-column prop="sendTime" label="发送时间" width="150"></el-table-column>
            <el-table-column prop="callbackTime" label="通知时间" width="150"></el-table-column>
        </el-table>
        <el-pagination
                @size-change="query"
                @prev-click="clickPrev"
                @next-click="clickNext"
                :page-sizes="[10, 20, 30, 50]"
                :page-size.sync="limit"
                :current-page.sync="page"
                :total="total"
                layout="total, sizes, slot, prev, next"
                prev-text="上一页"
                next-text="下一页">
            <el-button type="text" disabled>第{{page}}页</el-button>
        </el-pagination>
    </div>
</template>

<script>
    import FormItem from '@/components/FormItem'
    import moment from 'moment'

    export default {
        components: {
            FormItem
        },
        data() {
            return {
                form: {
                    configs: [
                        {label: "业务", name: "code", type: "cascade", op: "beginwith", value: ""},
                        {label: "手机号", name: "mobile", type: "input", value: "", style: "width: 130px"},
                        // {label: "通道", name: "channel", type: "select", value: "", options: []},
                        {
                            label: "状态", name: "status", type: "select", value: "", options: [
                                {label: "成功", value: "success"},
                                {label: "失败", value: "fail"},
                                {label: "未知", value: "unknown"},
                            ]
                        },
                        {label: "时间", name: "submitTime", type: "datetimerange", op: "between", value: [
                                moment().format("YYYY-MM-DD") + " 00:00:00",
                                moment().format("YYYY-MM-DD") + " 23:59:59",
                            ]
                        },
                        {label: "备注", name: "remark", type: "input", value: "", style: "width: 130px"},
                    ],
                    tools: [
                        {
                            label: "导出",
                            click: () => {
                              this.$confirm("确认进行导出操作？", "提示", {
                                confirmButtonText: "确认",
                                cancelButtonText: "取消",
                                type: 'warning'
                              }).then(() => {
                                this.$axios.post('/smsdown/download', this.getQueryInfo()).then(response => {
                                  if (response.success) {
                                    this.$message(response['message']);
                                  } else {
                                    this.$message.error(response['message']);
                                  }
                                });
                              });
                            }
                        }
                    ]
                },
                channels: [],
                total: 0,
                data: [],
                page: 1,
                limit: 10,
                formDrawer: false,
                startRowKey: "",
                stopRowKey: "",
                pickOptions: {
                    disabledDate(time){
                        let now = moment(moment().format("YYYY-MM-DD"));
                        let date = moment(moment(time).format("YYYY-MM-DD"));
                        let i = now.diff(date, "days");
                        // return i < 0 || i > 6;
                        return i < 0;
                    }
                }
            }
        },
        mounted() {
            // let options = [];
            // this.$axios.post("/channel/list").then(results => {
            //     results.forEach(result => {
            //         options.push({value: result.code, label: result.name});
            //     });
            //
            //     this.$set(this.form.configs[2], 'options', options);
            //     this.channels = options;
            //     this.query();
            // });
          this.query();
        },
        methods: {
            getChannelName(val) {
                let name = "";
                this.channels.forEach(option => {
                    if (val === option.value) {
                        name = option.label;
                        return false;
                    }
                });
                return name;
            },
            query() {
                this.formDrawer = false;
                this.$axios.post('/smsdown/paging', this.getQueryInfo()).then(result => {
                    if (result['total'] !== undefined) {
                        this.total = result['total'];
                    }
                    this.data = result['rows'];
                })
            },
            reload() {
                this.startRowKey = "";
                this.stopRowKey = "";
                this.page = 1;

                this.query();
            },
            clear() {
                this.form.configs.forEach(config => {
                    if (config.name === "submitTime") {
                      config.value = [
                        moment().format("YYYY-MM-DD") + " 00:00:00",
                        moment().format("YYYY-MM-DD") + " 23:59:59",
                      ];
                    } else {
                      config.value = null;
                    }
                });
            },
            clickPrev() {
                if (this.data.length > 0) {
                    this.startRowKey = this.data[0]['id'];
                }
                this.stopRowKey = "";
                this.query();
            },
            clickNext() {
                this.startRowKey = "";
                if (this.data.length > 0) {
                    this.stopRowKey = this.data[this.data.length - 1]['id'];
                }
                this.query();
            },
            getQueryInfo() {
                let queryInfo = {
                    limit: this.limit,
                    rules: []
                };

                this.form.configs.forEach((config, index) => {
                    let value = config['value'];
                    if (index === 3) {
                        if (value && value.length === 2) {
                            queryInfo['rules'].push({field: "submitTime", value: this.form.configs[3].value});
                        }
                    } else if (value) {
                        queryInfo['rules'].push({field: config['name'], value: value});
                    }
                });

                if (this.startRowKey) {
                    queryInfo['rules'].push({field: "startRowKey", value: this.startRowKey});
                }
                if (this.stopRowKey) {
                    queryInfo['rules'].push({field: "stopRowKey", value: this.stopRowKey});
                }

                return queryInfo;
            }
        }
    }
</script>

<style scoped>
    >>> .table-expand label {
        color: #99a9bf;
    }

    >>> .table-expand .el-form-item {
        margin-bottom: 0;
    }

    >>> .table-expand .el-form-item * {
        line-height: 30px;
    }
</style>